import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import MultiColumnsInsight from '../../../components/MultiColumnsInsight';
import AllBlogs from '../../../components/AllBlogs';

export default function PodcastsPage({
    global,
    all_podcasts,
}) {
    return (
        <>
            <SeoHead
                page_name={`Podcasts | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`podcasts`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`podcasts_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Podcasts</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-insights.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <AllBlogs
                global={global}
                pathPrefix={`podcasts_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_podcasts}
                ParentNews={true}
                locale={`us/`}
                cardPagePrefix={`podcasts/`}
                enableFilterBy={false}
            />
            <MultiColumnsInsight
                global={global}
                pathPrefix={`podcasts_page.multi_columns_insight`}
                customClass={`py-5`}
                left_column_content={
                    <>
                        <h2>Want to Know More?</h2>
                    </>
                }
                left_column_button_title_1={`Get in Touch`}
                left_column_button_link_1={`/us/contact-us/`}
                left_column_button_title_2={`Search More Blogs`}
                left_column_button_link_2={`/us/insights/`}
                // center_column_content={
                //     <>
                //         <h2>Subscribe to our newsletter</h2>
                //         <p>With insight across the whole of Lorien, we'll keep you ahead of the curve on the talent market.</p>
                //     </>
                // }
                // center_formId={`f2973c34-4388-4cf9-b22e-2a16efc93e2a`}
                // right_column_content={
                //     <>
                //         <h2>Download our Latest Report</h2>
                //         <p>Fill out the form below to gain exclusive access to the report</p>
                //     </>
                // }
                // right_formId={`614b4743-332c-41a0-8305-642d5eadd0a7`}
                // center_column_successPageUrl={`/us/insights/subscription-success`}
                // right_column_successPageUrl={`/us/insights/subscription-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const podcasts = (await Collection('podcasts'))
        .filter(function (post) {
            return (
                post.country?.en.includes("United States")
            );
        });

    const all_podcasts = podcasts.orderBy('title').getItems();

    return {
        props: {
            global,
            all_podcasts,
        }
    };
}
